// extracted by mini-css-extract-plugin
export default {"confirmation":"confirmation_confirmation__zEaLd","main":"confirmation_main__uVGBM","sub":"confirmation_sub__tHCZz","back-button":"confirmation_back-button__Cvsgy"};